import { Commit } from 'vuex'

import Country from '@/models/country'

import axios from '@/axios-module'

interface State {
  nationalities: string[]
  countries: Country[]
}

const initialState: State = {
  nationalities: [],
  countries: [],
}

export enum ProfileDataActionTypes {
  LoadNationalities = '[ProfileData] LoadNationalities',
  LoadCountries = '[ProfileData] loadCountries',
}

export enum ProfileDataMutationTypes {
  UpdateNationalities = '[ProfileData] UpdateNationalities',
  UpdateCountries = '[ProfileData] UpdateCountries',
}

export default {
  state: initialState,
  getters: {
    nationalities(state: State) {
      const popular = ['Australian', 'New Zealander', 'British', 'American']
      return {
        popular,
        regular: state.nationalities.filter((n) => popular.indexOf(n) < 0),
      }
    },
    countries(state: State) {
      return state.countries
    },
  },
  actions: {
    async [ProfileDataActionTypes.LoadNationalities]({
      commit,
    }: {
      commit: Commit
    }) {
      const response = await axios.get('/customer/nationalities')
      commit(ProfileDataMutationTypes.UpdateNationalities, response.data)
    },
    async [ProfileDataActionTypes.LoadCountries]({
      commit,
    }: {
      commit: Commit
    }) {
      const response = await axios.get('/customer/countries')
      commit(ProfileDataMutationTypes.UpdateCountries, response.data)
    },
  },
  mutations: {
    [ProfileDataMutationTypes.UpdateNationalities](
      state: State,
      nationalities: string[],
    ) {
      state.nationalities = nationalities
    },
    [ProfileDataMutationTypes.UpdateCountries](
      state: State,
      countries: Country[],
    ) {
      state.countries = countries
    },
  },
}
